/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { TextareaProps as ChakraTextareaProps } from '@chakra-ui/react';

import { ThemeComponent } from '@types';

import { colors } from '../foundations';
import { getColorSchemeOrDefault } from '../utils/variants';

export type InterpolationInputSizes = 'sm' | 'md' | 'lg' | string;
export type InterpolationInputVariants = 'default';

export const InterpolationInput: ThemeComponent<
  InterpolationInputSizes,
  InterpolationInputVariants,
  ChakraTextareaProps
> = {
  baseStyle: () => ({
    outline: 'none',
    padding: 'md',
    borderRadius: 'xs',
    transitionDuration: '0.1s',
    fontFamily: 'body',
  }),

  sizes: {
    sm: {
      fontSize: 'sm',
      lineHeight: 'sm',
    },
    md: {
      fontSize: 'md',
      lineHeight: 'md',
    },
    lg: {
      fontSize: 'lg',
      lineHeight: 'lg',
    },
  },

  variants: {
    default: ({ colorScheme }) => {
      const colorSchemeDefault = getColorSchemeOrDefault({
        colorScheme,
        colorSchemeDefault: 'ui',
      });

      return {
        border: 'sm',
        color: `${colorSchemeDefault}.700`,
        borderColor: `${colorSchemeDefault}.200`,
        _placeholder: {
          color: `${colorSchemeDefault}.500`,
        },
        _hover: {
          borderColor: `${colorSchemeDefault}.500`,
        },
        _focus: {
          border: 'md',
          borderColor: 'primary.500',
          boxShadow: `0px 0px 0px 3px ${colors.primary[100]}`,
        },
        _disabled: {
          cursor: 'not-allowed',
          background: 'ui.50',
          borderColor: `${colorSchemeDefault}.200`,
        },
        _invalid: {
          borderColor: 'supportA.600',
          _focus: {
            boxShadow: `0px 0px 0px 3px ${colors.supportA[100]}`,
          },
        },
      };
    },
  },

  defaultProps: {
    size: 'md',
    variant: 'default',
    colorScheme: null,
  },
};
